"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var widgets_1 = require("@tableau/widgets");
var Colors = widgets_1.TabStyles.Colors || {};
exports.DataGridColors = {
    Selected: '#cde7f8',
    // Hover: Colors.F3,
    AltRow: Colors.F2,
    HeaderBorder: Colors.L5,
    HorizontalGridLine: Colors.L2_5,
    SelectedGridLine: 'white',
    VerticalGridLine: Colors.L4,
};
//# sourceMappingURL=DataGridColors.js.map